export default __webpack_public_path__ + "static/media/menu.764a8814.svg";